import transcriptEpics from './epics';
import reducer from './reducers';
import * as transcriptSelectors from './selectors';
import * as transcriptTypes from './types';

export { transcriptSelectors, transcriptTypes, transcriptEpics };

export default reducer;
